import {
    GATEWAYHISTORY_SUCCESS,
    GATEWAYHISTORY_FAILED,
    RESET_GATEWAYHISTORY,
    LOADING_GATEWAYHISTORY,
    NETWORK_ERROR_GATEWAYHISTORY
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GATEWAYHISTORY:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GATEWAYHISTORY_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GATEWAYHISTORY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GATEWAYHISTORY:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GATEWAYHISTORY:
            return (state = initialState);
        default:
            return state;
    }
};
